import React, { Suspense } from "react";

import { LoadingModule } from "@/components";

const WeighingRoutes = React.lazy(() => import("./WeighingRoutes"));

export default function ModuleLazy() {
  return (
    <Suspense fallback={<LoadingModule />}>
      <WeighingRoutes />
    </Suspense>
  );
}
